import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { GridDirective } from '@df/ui/atomic/atom/grid/grid.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent } from '@icms/core/content';
import { ButtonStyleComponent } from 'projects/app-default/src/app/common/buttons/button-style/button-style.component';
import { NPageHeader } from '../../../page-header.component';

export const MEGANAV_CONTENT_ITEM_COMPONENT_ID = 'meganav-content-item';

@Component({
    imports: [GridDirective, ButtonStyleComponent, ICmsClientModule, HrefComponent, DfModuleImageModule],
    selector: 'page-header-meganav-content-item',
    templateUrl: 'page-header-meganav-content-item.html',
    styleUrl: './page-header-meganav-content-item.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageHeaderMeganavContentItemComponent>({
    id: MEGANAV_CONTENT_ITEM_COMPONENT_ID,
    name: 'Meganav content item',
    onDemandOnly: true,
    fields: NPageHeader.meganavItemFields
})
export class PageHeaderMeganavContentItemComponent extends UiComponent {
    readonly ESubmenuLayout = NPageHeader.ESubmenuLayout;

    @ICmsContent({
        type: 'component'
    })
    @Input()
    component?: NPageHeader.IMeganavItem;

    readonly bannerActive = signal(false);

    toggleActive(value: boolean): void {
        this.bannerActive.set(value);
        this.detectChanges();
    }
}
